
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';  // needed for <router-outlet>
import { MainHeader } from '@shared-components/main-header/main-header';
import { MainSidebar } from '@shared-components/main-sidebar/main-sidebar';


/**
 * DefaultLayout component.
 * Provides the main layout structure for the application,
 * including header, sidebar, and router outlet for page content.
 */
@Component({
  selector: 'app-default-layout',
  standalone: true,

  imports: [
    MainHeader,
    MainSidebar,
    RouterModule
  ],

  templateUrl: './default-layout.html',
  styleUrls: ['./default-layout.scss']
})
export class DefaultLayout {
  constructor
    () { }

}
